import { render, staticRenderFns } from "./addMonthlyTemplate.vue?vue&type=template&id=34adc84b&"
import script from "./addMonthlyTemplate.vue?vue&type=script&lang=js&"
export * from "./addMonthlyTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports